import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import {
    AgentLinkRequestDTO,
    AgentResponseDTO,
    InstitutionsLinkAgentQueryDTO,
    InstitutionsQueryDTO,
    InstitutionsRequestDTO,
    InstitutionsResponseDTO,
    InstitutionUserPerfis,
    UsersNewResponseDTO,
    UsersQueryDTO,
    UsersRequestDTO,
    UsersResponseDTO
} from 'models'
import { FormFileDataProps } from 'pages/Institution/components/Attachments/components/SendingFiles/interface'
import { IAttachments } from 'pages/Institution/components/Attachments/interfaces'
import api from './api'

const { ENDPOINT_API_INSTITUTIONS, ENDPOINT_API_USERS } = environments

const createInstitutions = async (
    data: InstitutionsRequestDTO
): Promise<AxiosResponse<InstitutionsResponseDTO>> => {
    return await api.post(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras`,
        data
    )
}

const editBasicDataInstitutions = async (
    data: InstitutionsRequestDTO,
    idInstitution: string
): Promise<AxiosResponse<InstitutionsResponseDTO>> => {
    return await api.put(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}`,
        data
    )
}

const getInstitutions = async (
    query?: InstitutionsQueryDTO
): Promise<AxiosResponse<InstitutionsResponseDTO[]>> => {
    return await api.get(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras?${new URLSearchParams(
            Object.assign(query ?? {})
        )}`,
        {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('idToken')}`
            }
        }
    )
}

const toogleStatusInstitutionById = (
    idInstitution: string,
    isActive: boolean
) => {
    return api.put(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}/status?ativa=${isActive}`
    )
}

const deleteInstitutionById = (
    idInstitution: string,
) => {
    return api.delete(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}`
    )
}


const getInstitution = async (
    id?: string
): Promise<AxiosResponse<InstitutionsResponseDTO>> => {
    return await api.get(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}`
    )
}

const createInstitutionUser = async (
    id: string,
    data: UsersRequestDTO
): Promise<AxiosResponse<UsersResponseDTO>> => {
    return await api.post(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/usuarios`,
        data
    )
}

const editInstitutionUser = async (
    id: string,
    idUser: string,
    data: UsersRequestDTO
): Promise<AxiosResponse<UsersResponseDTO>> => {
    return await api.put(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/usuarios/${idUser}`,
        data
    )
}

const getInstitutionUser = async (
    id: string,
    idUser: string,
    isBackoffice?: boolean
): Promise<AxiosResponse<UsersNewResponseDTO>> => {
    if (!isBackoffice) {
        return await api.get(
            `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/usuarios/${idUser}`
        )
    } else {
        return await api.get(`${ENDPOINT_API_USERS}/usuarios/${idUser}`)
    }
}

const getInstitutionUsers = async (
    id: string,
    query?: UsersQueryDTO
): Promise<AxiosResponse<UsersResponseDTO[]>> => {
    return await api.get(
        `${ENDPOINT_API_USERS}/usuarios/instituicoes-financeiras/${id}?${new URLSearchParams(
            Object.assign(query ?? {})
        )}`,
        {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('idToken')}`
            }
        }
    )
}

const getInstitutionsPerfis = async (): Promise<
    AxiosResponse<InstitutionUserPerfis[]>
> => {
    return await api.get(`${ENDPOINT_API_USERS}/usuarios/perfis`, {
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('idToken')}`
        }
    })
}

const getLinkInstitutionAgent = async (
    id: string,
    query?: InstitutionsLinkAgentQueryDTO
): Promise<AxiosResponse<AgentResponseDTO[]>> => {
    return await api.get(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/agentes-financeiros?${new URLSearchParams(
            Object.assign(query ?? {})
        )}`
    )
}

const getAttachmentsByInstitutions = (
    id: string,
    query?: any
): Promise<AxiosResponse<IAttachments[]>> => {
    return api.get(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/anexos?${new URLSearchParams(
            Object.assign(query ?? {})
        )}`
    )
}

const downloadAttachmentsByInstitutions = (
    idAttachment: string,
    query?: any
): Promise<AxiosResponse<IAttachments[]>> => {
    return api.get(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/anexos/${idAttachment}`
    )
}

const postUploadAttachmentByInstitutions = (
    id: string,
    body: FormFileDataProps
) => {
    return api.post(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/anexos`,
        {
            ...body
        }
    )
}

const deleteAttachmentsByInstitutions = (
    id: string,
    idAttachment: string
): Promise<AxiosResponse<IAttachments[]>> => {
    return api.delete(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/anexos/${idAttachment}`
    )
}

const getInstitutionAgent = async (
    id: string,
    query?: InstitutionsLinkAgentQueryDTO
): Promise<AxiosResponse<AgentResponseDTO[]>> => {
    return await api.get(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/agentes-financeiros-filtro?${new URLSearchParams(
            Object.assign(query ?? {})
        )}`
    )
}

const createLinkInstitutionAgent = async (
    id: string,
    data: AgentLinkRequestDTO
): Promise<AxiosResponse<void>> => {
    return await api.post(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/agentes-financeiros`,
        data
    )
}

const deleteLinkInstitutionAgent = async (
    id: string,
    idAgent: string
): Promise<AxiosResponse<void>> => {
    return await api.delete(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${id}/agentes-financeiros/${idAgent}`
    )
}

const InstitutionsService = {
    createInstitutions,
    getInstitutions,
    getInstitution,
    getInstitutionUser,
    createInstitutionUser,
    editInstitutionUser,
    getInstitutionUsers,
    getInstitutionsPerfis,
    getLinkInstitutionAgent,
    createLinkInstitutionAgent,
    deleteLinkInstitutionAgent,
    editBasicDataInstitutions,
    getInstitutionAgent,
    getAttachmentsByInstitutions,
    deleteAttachmentsByInstitutions,
    postUploadAttachmentByInstitutions,
    downloadAttachmentsByInstitutions,
    toogleStatusInstitutionById,
    deleteInstitutionById
}

export default InstitutionsService
